import { defineStore } from 'pinia'
import { ref, toRef, watch, watchEffect } from 'vue'
import type { InventoryMapInfoType } from '@/entities/Inventory/Main'
import useValidate from '@/shared/lib/validate'
import type { InventReplaceInfoData } from './../model/types.ts'
import { useLoadInventDocuments } from '@/entities/Inventory/Documents'

export const useInventObjectReplace = defineStore('invent_object_replace', () => {
  const openForm = ref(false)
  const object = ref<InventoryMapInfoType | null>(null)
  const data = ref<InventoryMapInfoType | null>(null)

  const documentList = ref<{ id: number; name: string }[]>([])

  /** УДАЛИТЬ КОГДА ПОЯВИТЬСЯ СЛОВАРЬ **/
  const changeTypes = [
    { id: 1, name: 'Замена светильников' },
    { id: 2, name: 'Демонтаж оборудования 3-х лиц' },
    { id: 3, name: 'Реставрация опоры' },
    { id: 4, name: 'Замена светильников (Адресная программа 1)' },
    { id: 5, name: 'Замена светильника (ремонт)' },
  ]

  const { required, fileTypes } = useValidate()

  const infoData = ref<InventReplaceInfoData>({
    document: null,
    document_id: 0,
    change_type: 1,
    comment: '',
  })

  /** Правила валидации **/
  const rules = {
    document: [
      (value: File) =>
        fileTypes(
          [value],
          [
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          ],
        ),
    ],
    change_type: [(value: any) => required(value)],
  }

  /** Функция очистки данных **/
  const cleanData = () => {
    openForm.value = false

    setTimeout(() => {
      object.value = null
      data.value = null
      infoData.value.document = null
      infoData.value.change_type = 1
      infoData.value.comment = ''
    }, 300)
  }

  /** Получение списка различий **/
  const getReferenceData = () => {
    if (!object.value || !data.value) return null

    /** Добавляем данные для формы **/
    const submitData = new FormData()
    submitData.append('object_list_id', String(object.value.id))
    submitData.append('fields', JSON.stringify(data.value.fields))

    submitData.append('change_type_id', String(infoData.value.change_type))
    submitData.append('change_comment', infoData.value.comment)

    submitData.append('document_id', String(infoData.value.document_id))

    if (infoData.value.document) {
      const document = infoData.value.document as File
      const splitName: string[] = document.name.split('.')
      const ext: string = splitName.pop() || ''

      submitData.append('document.file', document)
      submitData.append('document.name', document.name)
      submitData.append('document.ext', ext)
      submitData.append('document.size', String(document.size))
    }

    return submitData
  }

  /**
   * Функция загрузки списка документов
   */
  const loadDocumentsList = () => {
    const result = useLoadInventDocuments(toRef({ type: 'replace' }))

    watchEffect(() => {
      watch(result.data, () => {
        if (result.data.value) documentList.value = [{ id: 0, name: '' }, ...result.data.value.data]
      })
    })

    return result
  }

  return {
    openForm,
    object,
    data,
    infoData,
    rules,
    changeTypes,
    documentList,

    cleanData,
    getReferenceData,
    loadDocumentsList,
  }
})
